// src/services/api/phoneBlacklist.js
import { apiClient } from './base';

export const getPhoneBlacklist = async (params = {}) => {
  try {
    const response = await apiClient.get('/phone-blacklist', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addPhoneBlacklist = async (data) => {
  try {
    const response = await apiClient.post('/phone-blacklist', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updatePhoneBlacklist = async (id, data) => {
  try {
    const response = await apiClient.put(`/phone-blacklist/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deletePhoneBlacklist = async (id) => {
  try {
    const response = await apiClient.delete(`/phone-blacklist/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkBlacklistedPhones = async (phones) => {
  try {
    const response = await apiClient.get('/phone-blacklist/check', {
      params: { phones: phones.join(',') },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
